var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classNames from 'classnames';
import { Flag } from 'Permafrost/index';
import { StyledSectionBlock } from './SectionBlock.styles';
export const SectionBlock = (props) => {
    const { title, className, children, id, style = {}, flagText, flagMessage } = props, restOfProps = __rest(props, ["title", "className", "children", "id", "style", "flagText", "flagMessage"]);
    return (React.createElement(StyledSectionBlock, Object.assign({ className: classNames('SectionBlock', className), "data-cy": props['data-cy'], id: id, style: style }, restOfProps),
        title ? (React.createElement("header", { className: "SectionBlock--header", style: { display: 'flex', alignItems: 'center' } },
            React.createElement("div", { className: "header-container" },
                React.createElement("h3", null, title),
                flagText ? React.createElement(Flag, { text: flagText }) : null),
            flagMessage ? React.createElement("p", { className: "SectionBlock__flag-message" }, flagMessage) : null)) : null,
        children,
        React.createElement("hr", { className: "section-bottom-border" })));
};
//# sourceMappingURL=SectionBlock.js.map